module.exports = __webpack_public_path__ + "img/ennetix-application-detail-page-alerts-panel2.9f29ef4a.png";